"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _constants = require("../constants");

/**
  * Metrics Payload Event
  * Emitted when a Metric Payload is available
  * @event metrics:payload
  * @instance
  * @type {Object}
  * @memberof MediaMetrics
  */

/**
 * @class MediaMetrics
 * @private
 */
var MediaMetrics = /*#__PURE__*/function () {
  /**
   * @param {Object} options
   * @param {Object} options.config
   * @memberof MediaMetrics
   * @constructor
   */
  function MediaMetrics() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, MediaMetrics);
    (0, _defineProperty2.default)(this, "namespace", _constants.MEETINGS);
    this.config = options.config;
    this.stats = null;
  }
  /**
   * @param {MeetingStats} stats
   * @returns {undefined}
   * @memberof MediaMetrics
   */


  (0, _createClass2.default)(MediaMetrics, [{
    key: "setStats",
    value: function setStats(stats) {
      this.stats = stats;
    }
    /**
     * sets up all the default senders and receivers getStats to collect data
     * @returns {Object}
     * @public
     * @memberof MediaMetrics
     */

  }, {
    key: "initialize",
    value: function initialize() {
      var mqa = this.config.metrics.autoSendMQA;
      return {
        useConfig: true,
        senders: [{
          id: _constants.STATS.AUDIO_SENDER_ID,
          correlate: _constants.STATS.AUDIO_CORRELATE,
          mqa: mqa,
          onData: function onData() {}
        }, {
          id: _constants.STATS.VIDEO_SENDER_ID,
          correlate: _constants.STATS.VIDEO_CORRELATE,
          mqa: mqa,
          onData: function onData() {}
        }, {
          id: _constants.STATS.SHARE_SENDER_ID,
          correlate: _constants.STATS.SHARE_CORRELATE,
          mqa: mqa,
          onData: function onData() {}
        }],
        receivers: [{
          id: _constants.STATS.AUDIO_RECEIVER_ID,
          correlate: _constants.STATS.AUDIO_CORRELATE,
          mqa: mqa,
          onData: function onData() {}
        }, {
          id: _constants.STATS.VIDEO_RECEIVER_ID,
          correlate: _constants.STATS.VIDEO_CORRELATE,
          mqa: mqa,
          onData: function onData() {}
        }, {
          id: _constants.STATS.SHARE_RECEIVER_ID,
          correlate: _constants.STATS.SHARE_CORRELATE,
          mqa: mqa,
          onData: function onData() {}
        }]
      };
    }
  }]);
  return MediaMetrics;
}();

exports.default = MediaMetrics;
//# sourceMappingURL=metrics.js.map
